/**
 * Venue text for an external event (BTK 9465).
 *
 * The event carries city, district and a free-text address; which of them a
 * surface shows depends on how much room it has, but the ORDER and separator
 * must not drift between the card, the apply modal and the mail — so both
 * shapes live here.
 */

export interface VenueParts {
  city?: string;
  district?: string;
  address?: string;
}

const SEPARATOR = ' · ';

/** City and district only — for a card's place line, where an address would wrap. */
export function shortVenue(parts: VenueParts): string {
  return [parts.city, parts.district].filter(Boolean).join(SEPARATOR);
}

/**
 * Everything the operator entered, for surfaces where the reader is deciding
 * whether to attend (apply modal, my-events). Falls back to the short form when
 * no address was entered.
 */
export function fullVenue(parts: VenueParts): string {
  return [parts.city, parts.district, parts.address].filter(Boolean).join(SEPARATOR);
}
